import React from "react";
import styled from "styled-components";
const Styles = styled.div`
  background-color: ${(props) => props.backgroundColor};
  .main-container {
    height: ${(props) => props.height};
    padding-top: ${(props) => props.paddingTop};
    color: var(--dark-purple);
  }
`;
const Error = (props) => {
  const { color, backgroundColor, height, paddingTop, message, notCenter } =
    props;
  return (
    <Styles
      backgroundColor={backgroundColor}
      height={height}
      paddingTop={paddingTop}
      color={color}
    >
      <div className={`error main-container ${!notCenter && "text-center"}`}>
        {message}
      </div>
    </Styles>
  );
};

export default Error;
